import HttpRequest from "./http";

const http = new HttpRequest();

export default http;
